module.exports = __webpack_public_path__ + "img/caret-down.2df51248.svg";